import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/packagesSalesSaga";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";

const SecondaryCategory = () => {
  const dispatch = useDispatch();

  const secondaryCategoriesLoading = useSelector(
    (state) => state.packagesSales.secondaryCategoriesLoading
  );
  const secondaryCategories = useSelector(
    (state) => state.packagesSales.filters.secondary_categories
  );
  const selectedSecondaryCategories = useSelector(
    (state) => state.packagesSales.selectedFilters.secondary_categories
  );

  return secondaryCategoriesLoading ? (
    <LoadingAnimation uiLoader />
  ) : (
    <MultiSelectDropdown
      options={secondaryCategories}
      selectedFilters={selectedSecondaryCategories}
      placeholder="Secondary Categories"
      numberDisplayed={0}
      includeSelectAll
      enableOnly
      height={324}
      onSelectChange={(data) => dispatch(actionCreators.updateSecondaryCategory(data))}
    />
  );
};

export default SecondaryCategory;
